import { forWeb } from '@ff-os/shared-utils/asset-urls';

export const loadSvg = async (url: string, language: string) => {
    const response = await fetch(forWeb(url, { w: 1000, h: 1000, language }), { mode: 'cors' });
    if (response.ok) {
        return await response.text();
    } else {
        throw new Error(`SVG load error: ${url} [${response.status}]`);
    }
};